let StarterCampaignsIndexTourSteps  = {
  tourSteps: function() {
    return [
        {
          content: 'The Library page lists workflows you can copy to get started.',
          target: '.help_icon_smaller',
          placement: 'bottom',
          disableBeacon: true
        },
        {
          content: 'This is the name of the workflow.',
          target: '.campaign_name',
          placement: 'top',
          disableBeacon: true
        },
        {
          content: "This category for the workfllow.",
          target: '.campaign_category',
          placement: 'top',
          disableBeacon: true
        },
        {
          content: 'This is the author of the workflow.',
          target: '.campaign_author',
          placement: 'top',
          disableBeacon: true
        },
        {
          content: 'This is the description of the workflow.',
          target: '.campaign_description',
          placement: 'top',
          disableBeacon: true
        },
        {
          content: 'This is the number of email steps in this workflow.',
          target: '.campaign_step_email',
          placement: 'top',
          disableBeacon: true
        },
        {
          content: 'This is the number of SMS steps in this workflow.',
          target: '.campaign_step_sms',
          placement: 'top',
          disableBeacon: true
        },
        {
          content: 'This is the number task steps in this workflow.',
          target: '.campaign_step_task',
          placement: 'top',
          disableBeacon: true
        },
        {
          content: "Click here to copy this workflow.",
          target: '.template_btn_use',
          placement: 'top',
          disableBeacon: true
        },
        {
          content: "Click here to see more information about workflow.",
          target: '.template_btn_more_info',
          placement: 'top',
          disableBeacon: true
        }
    ];
  }
};
export default StarterCampaignsIndexTourSteps;
